const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)

export default [
  {
    path: '/reports',
    name: 'Reports',
    component: _import('reports/components/wrapper'),
    redirect: '/reports/shift',
    meta: {
      showInMenu: true,
      title: 'Отчеты',
      menuKey: 'reports',
      roles: ['ROLE_ADMIN', 'ROLE_WAITER']
    },
    children: [
      {
        path: 'shift',
        name: 'Reports.shift',
        component: _import('reports/components/shiftReport'),
        meta: {
          menuKey: 'reports',
          title: 'Отчет за смену',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'salary',
        name: 'Reports.salary',
        component: _import('reports/components/salaryReport'),
        meta: {
          menuKey: 'reports',
          title: 'Отчет по зарплате',
          roles: ['ROLE_ADMIN']
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/reports/routes.js